export default __webpack_public_path__ + "6336586c5938fe48525a78f8da1aec22.png";